// Auto-generated cornerstone translation for hr.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:17:58.053275+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplikacija za upravljanje konjima: najbolji izbor za 2026. | EquiSight",
      description: "Usporedite aplikacije za upravljanje konjima za vlasnike, staje i uzgajivače. Otkrijte zašto je EquiSight najpotpunija aplikacija za vašeg konja.",
      keywords: [
        "aplikacija za upravljanje konjima",
        "aplikacija za upravljanje stajom",
        "aplikacija dnevnik konja",
        "aplikacija za upravljanje više konja",
        "aplikacija za praćenje gravidnosti kobila",
        "aplikacija za uzgoj konja",
        "najbolja aplikacija za upravljanje konjima",
      ],
    },
    hero: {
      eyebrow: "Vodič za odabir · softver za upravljanje konjima",
      breadcrumbLabel: "Aplikacija za upravljanje konjima",
      title: "Aplikacija za upravljanje konjima: potpuni vodič za odabir za vlasnike, staje i uzgajivače.",
      intro: "Ne samo popis značajki — poštena usporedba, vodič za odabir i uvid u to što aplikacija za upravljanje konjima zaista mora znati u 2026. Za jednog konja, cijelu staju ili vaš uzgoj.",
      pills: [
        {
          icon: "Users",
          label: "Za vlasnike",
        },
        {
          icon: "Building2",
          label: "Za staje",
        },
        {
          icon: "Baby",
          label: "Za uzgajivače",
        },
        {
          icon: "Share2",
          label: "Za timove",
        },
      ],
      ctas: [
        {
          label: "Počnite besplatno s 1 konjem",
          href: "#start",
          primary: true,
        },
        {
          label: "Na tablicu usporedbe",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zašto aplikacija za upravljanje konjima postaje sve važnija.",
      lead: "Upravljanje konjima u praksi je rascjepkano: WhatsApp, kalendar, Excel, fotografije na telefonu, papirnata putovnica, odvojeni računi i usmeni dogovori. Već s jednim konjem nezgodno. S više konja, uzgojem ili zajedničkom skrbi nastaju propusti, propušteni termini i nesporazumi.",
      items: [
        "Gdje je opet bio taj datum cijepljenja?",
        "Tko je platio kovača?",
        "Koja kobila treba biti pregledana danas?",
        "Je li trener uopće pročitao uputu od prošlog tjedna?",
        "Jesam li stvarno spremio/la tu foto-dokumentaciju?",
        "Je li plan prehrane koji visi u staji još uvijek točan?",
      ],
    },
    what: {
      title: "Što je aplikacija za upravljanje konjima?",
      lead: "Aplikacija za upravljanje konjima u osnovi je digitalni dosje po konju. Nikakvih rascjepkanih bilješki, već jedno mjesto za zdravlje, trening, prehranu, dokumente, planiranje, podsjetnike, troškove, fotografije, videozapise i dijeljeni pristup. Svi oko konja gledaju u iste, ažurne informacije.",
      targetGroupsTitle: "Kome je namijenjena aplikacija za upravljanje konjima?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privatni vlasnik",
          body: "Jedan konj, jedan dosje — zdravlje, planiranje i povijest u džepu.",
        },
        {
          icon: "Users",
          title: "Vlasnik s više konja",
          body: "Zasebni profili, zasebno planiranje, zajednički popis zadataka za cijeli tim.",
        },
        {
          icon: "Building2",
          title: "Staja za pension i jahački klub",
          body: "Pristup vlasnicima, upute za njegu, zajednički kalendar i zadaci.",
        },
        {
          icon: "Baby",
          title: "Uzgajivač",
          body: "Ciklus kobila, gravidnost, podaci o pastusima, rodovnik i razvoj ždrebadi.",
        },
        {
          icon: "Target",
          title: "Treneri",
          body: "Uvid po konju, bilježenje treninga, postavljanje ciljeva, analiza videozapisa.",
        },
        {
          icon: "ClipboardList",
          title: "Stručnjaci",
          body: "Kovač, zubar, fizioterapeut ili veterinar — rade iz istog dosjea.",
        },
      ],
    },
    criteria: {
      title: "Što mora ispunjavati dobra aplikacija za upravljanje konjima?",
      lead: "Aplikacija nije samo lijepa — mora svakodnevno raditi u praksi. Pet komponenti koje ne smiju nedostajati pri odabiru u 2026.",
      items: [
        {
          icon: "FileText",
          title: "Dosje po konju",
          body: "Podaci, dob, pasmina, informacije iz putovnice, vlasnik, staja, fotografije i dokumenti — sve povezano s jednim profilom konja.",
        },
        {
          icon: "Heart",
          title: "Zdravlje i njega",
          body: "Cijepljenja, dehelmintizacija, kovač, zubar, veterinar, tretmani, lijekovi i automatski podsjetnici prije isteka roka.",
        },
        {
          icon: "Activity",
          title: "Trening i napredak",
          body: "Bilježenje treninga, bilješke, videozapisi, rezultati natjecanja, ciljevi i napredak po disciplini ili po konju.",
        },
        {
          icon: "Apple",
          title: "Prehrana i upravljanje",
          body: "Planovi prehrane, dodaci, voluminozna krma, težina, tjelesna kondicija i dnevna rutina koju staja mora poznavati.",
        },
        {
          icon: "Share2",
          title: "Dijeljenje s drugima",
          body: "Pristup za vlasnika, njegovatelja, trenera, vlasnika staje ili stručnjaka — s upravljanjem pravima prilagođenim ulozi svake osobe.",
        },
        {
          icon: "Calendar",
          title: "Planiranje i podsjetnici",
          body: "Zajednički kalendar sa zadacima, automatskim podsjetnicima i potvrdom kako ništa ne bi prošlo nezapaženo.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostale aplikacije za upravljanje konjima.",
      lead: "Trenutačno se na tržištu pojavljuju Stalmanager, LogMyHorse, EquineM i Happie Horse. Svaki ima svoje prednosti. Uspoređujemo najtraženije funkcije jedna uz drugu — pošteno i na temelju javno dostupnih informacija.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Besplatan početak",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Više konja",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zdravstveni dosje",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Trening i napredak",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Prehrana i dodaci",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planiranje i podsjetnici",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenti po konju",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dijeljenje s timom i prava",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modul za uzgoj (potpun)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ciklus kobila",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planiranje gravidnosti + ehosonografije",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Razvoj ždrebadi",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracija stručnjaka",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach uvidi",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prikladno za vlasnike",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Prikladno za uzgajivače",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prikladno za staju/jahački klub",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Usporedba temeljena na javno dostupnim značajkama iz siječnja 2026. Konkurenti su također dobri alati; EquiSight je izgrađen kako bi sve module kombinirao u jednoj aplikaciji.",
    },
    why: {
      title: "Zašto je EquiSight drugačiji.",
      lead: "Dnevnik bilježi. EquiSight kombinira upravljanje konjima, trening, prehranu, zdravlje, natjecanja, stručnjake i uzgoj u jednoj modernoj aplikaciji — i ide korak dalje s uvidima.",
      points: [
        {
          icon: "Heart",
          title: "Jedna aplikacija za cijeli život konja",
          body: "Od ždrebeta do sportskog konja, rasplodne kobile ili konja u mirovini. Dosje raste zajedno s vašim konjem — ništa se ne gubi na putu.",
        },
        {
          icon: "Sparkles",
          title: "Ne samo podaci, već i uzorci",
          body: "EquiCoach kombinira razvoj, ponavljajuće tegobe, trening i prehranu — kako biste pravovremeno uočili signale, a ne izolirane dojave.",
        },
        {
          icon: "Share2",
          title: "Izgrađen za suradnju",
          body: "Vlasnik, vlasnik staje, trener, kovač i drugi stručnjaci rade iz istog dosjea konja — s pravima koja odgovaraju njihovoj ulozi.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niša · uzgoj",
      title: "Upravljanje konjima za uzgajivače.",
      lead: "Mnogi konkurenti uzgoj spominju u jednoj rečenici. EquiSight je izgradio potpuni modul za uzgoj — jer uzgajivač rijetko je krajnji korisnik opće aplikacije, a planiranje mu je potrebno više nego ikome drugom.",
      items: [
        "Svakodnevno praćenje ciklusa kobila",
        "Datum osjemenjivanja + podaci o pastusima",
        "Kontrola gravidnosti s ehosonografijama",
        "Očekivani datum ždrijebljenja + upozorenja",
        "Razvoj ždrebeta po mjesecima",
        "Rodovnik i porijeklo",
        "Bilješke po kobili",
        "Pregled svih gravidnih kobila",
      ],
      ctaLabel: "Pogledajte modul za uzgoj",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niša · staja i jahački klub",
      title: "Upravljanje konjima za više konja i staje za pension.",
      lead: "S više konja, manje se radi o podacima, a više o komunikaciji. Svaki vlasnik ima vlastite želje, rutine, dogovore o prehrani i medicinske napomene. Svaki zaposlenik tome mora moći pristupiti bez traženja.",
      cards: [
        {
          t: "Konji po vlasniku",
          d: "Svaki vlasnik vidi samo svoje konje.",
        },
        {
          t: "Upute za njegu",
          d: "Vidljivo po konju za staju.",
        },
        {
          t: "Zajednički kalendar",
          d: "Kovač, veterinar i natjecanja u jednom pregledu.",
        },
        {
          t: "Popis zadataka",
          d: "Dodijelite zaposlenicima, s potvrdom.",
        },
        {
          t: "Pristup vlasnicima",
          d: "Klijenti vide svojeg konja u vlastitoj aplikaciji.",
        },
        {
          t: "Hitni kontakti",
          d: "Uvijek dostupni u stresnim situacijama u staji.",
        },
      ],
      ctaLabel: "Pogledajte modul za jahački klub",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Od WhatsAppa, Excela i bijele ploče do EquiSighta.",
      lead: "Konkretno: ovako se mijenja vaše svakodnevno upravljanje konjima.",
      rows: [
        {
          before: "WhatsApp grupe",
          after: "Strukturirane bilješke po konju",
        },
        {
          before: "Excel tablice",
          after: "Živi dosje konja s poviješću",
        },
        {
          before: "Bijela ploča u staji",
          after: "Zajednički raspored na vašem telefonu",
        },
        {
          before: "Odvojene fotografije na fotoaparatu",
          after: "Mediji povezani s vašim konjem",
        },
        {
          before: "Usmeni dogovori",
          after: "Zadaci i podsjetnici s potvrdom",
        },
        {
          before: "Izgubljena papirnata putovnica",
          after: "Dokumenti uvijek pri ruci",
        },
      ],
    },
    helper: {
      title: "Koja aplikacija za upravljanje konjima odgovara vama?",
      lead: "Odgovorite na ovih 5 pitanja i dobit ćete poštenu preporuku — čak i kada to nije uvijek EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Imate li jednog ili više konja?",
          options: [
            {
              label: "Jedan konj",
              score: 1,
            },
            {
              label: "2–5 konja",
              score: 2,
            },
            {
              label: "Više od 5 konja",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Upravljate li konjima klijenata ili trećih osoba?",
          options: [
            {
              label: "Ne, samo mojim vlastitim konjima",
              score: 0,
            },
            {
              label: "Ponekad — za obitelj ili poznanike",
              score: 1,
            },
            {
              label: "Da, profesionalno (staja / jahački klub)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Želite li pratiti uzgoj i gravidnost?",
          options: [
            {
              label: "Nije relevantno",
              score: 0,
            },
            {
              label: "Ponekad — povremeni uzgoj",
              score: 1,
            },
            {
              label: "Da, ja sam (ili ću biti) uzgajivač",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Surađujete li s trenerom, njegovateljem ili stručnjakom?",
          options: [
            {
              label: "Ne, sve radim sam/sama",
              score: 0,
            },
            {
              label: "Da, s jednom osobom",
              score: 1,
            },
            {
              label: "Da, s više osoba",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Želite li samo bilježiti ili i dobivati uvide?",
          options: [
            {
              label: "Samo bilježiti",
              score: 1,
            },
            {
              label: "Bilježiti + planirati",
              score: 2,
            },
            {
              label: "Bilježiti + planirati + uvidi",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednostavan dnevnik je dovoljan — i raste zajedno s vama.",
          body: "Za jednog konja bez zajedničke skrbi svaka aplikacija za upravljanje konjima je prikladna. EquiSight počinje besplatno s 1 konjem, tako da nema rizika. Ako kasnije budete htjeli dodati više konja, trenera ili uzgoj, sve je već ugrađeno.",
          cta: "Počnite besplatno s 1 konjem",
        },
        mid: {
          title: "EquiSight dobro odgovara vašoj situaciji.",
          body: "Imate više potreba (više konja, suradnja ili uvidi). Većina konkurenata pokriva 1–2 modula; EquiSight ih kombinira u jednoj aplikaciji, bez potrebe za povezivanjem odvojenih alata.",
          cta: "Pogledajte što EquiSight može",
        },
        high: {
          title: "EquiSight je najlogičniji izbor.",
          body: "Vaša situacija kombinira više konja, suradnju, uzgoj i/ili uvide. Upravo tu EquiSight čini razliku — nema rascjepkanih alata, već jedan dosje konja za sve i svakoga oko konja.",
          cta: "Počnite besplatno s EquiSightom",
        },
      },
    },
    faqTitle: "Često postavljana pitanja o aplikacijama za upravljanje konjima",
    faq: [
      {
        q: "Koja je najbolja aplikacija za upravljanje konjima?",
        a: "Najbolja aplikacija za upravljanje konjima ovisi o vašoj situaciji. Za jednostavan dnevnik prikladne su mnoge aplikacije. Ako želite kombinirati zdravlje, trening, prehranu, dokumente, uzgoj, planiranje i suradnju, EquiSight je izgrađen kao potpuno rješenje u kojemu se sve nalazi u jednom dosjeu.",
      },
      {
        q: "Mogu li upravljati s više konja u jednoj aplikaciji?",
        a: "Da. Dobra aplikacija za upravljanje konjima mora podržavati više konja, uključujući vlasnike, njegovatelje, rutine, dokumente, termine i podsjetnike po konju. EquiSight je za to osmišljen od prve linije koda — konji su zasebni doseji, a ne redovi na popisu.",
      },
      {
        q: "Je li EquiSight prikladan i za uzgajivače?",
        a: "Da. EquiSight se može postaviti s funkcijama uzgoja kao što su ciklus kobila, datum osjemenjivanja, kontrola gravidnosti, podaci o pastusima, rodovnik, očekivani datum ždrijebljenja i razvoj ždrebadi. Upravo je to područje na koje većina konkurentskih aplikacija ne reagira ili to čini tek djelomično.",
      },
      {
        q: "Mogu li dijeliti podatke sa svojim trenerom ili kovačem?",
        a: "Da. Cilj EquiSighta je da se relevantne informacije mogu sigurno dijeliti s osobama oko konja — trenerom, kovačem, zubarom, veterinarom, fizioterapeutom, njegovateljem ili vlasnikom. Svaka osoba dobiva samo ona prava koja su potrebna za njenu ulogu.",
      },
      {
        q: "Zašto ne koristiti samo WhatsApp ili Excel?",
        a: "WhatsApp i Excel funkcioniraju dok sve ostaje jednostavno. Čim imate više konja, termine, dokumente, tretmane, vlasnike ili podatke o uzgoju, pojavljuju se pogreške: informacije se rasipaju, pronalaženje oduzima vrijeme, a usmeni dogovori nestaju. Aplikacija za upravljanje konjima sve objedinjuje po konju, s automatskim podsjetnicima.",
      },
      {
        q: "Koliko košta EquiSight?",
        a: "Možete početi besplatno s 1 konjem. Ako želite upravljati s više konja, aktivirati uzgoj ili dati pristup stručnjacima, postoje pristupačni Premium planovi. Pogledajte aktualne opcije na stranici s cijenama.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software za uzgoj konja: potpuna usporedba 2026.",
      description: "Usporedite softver za uzgoj konja: ciklus kobile, bređost, izbor pastuha i ždrebad. Otkrijte zašto je EquiSight potpuna aplikacija za uzgoj.",
      keywords: [
        "software za uzgoj konja",
        "aplikacija za ciklus kobile",
        "aplikacija za bređost kobile",
        "aplikacija za registraciju ždrebeta",
        "aplikacija za matičnu knjigu konja",
        "planiranje parenja konja",
        "aplikacija za izbor pastuha",
      ],
    },
    hero: {
      eyebrow: "Pomoć pri odabiru · software za uzgoj",
      breadcrumbLabel: "Software za uzgoj",
      title: "Software za uzgoj konja: potpuna usporedba za 2026.",
      intro: "Kobila za uzgoj zaslužuje više od obične aplikacije za upravljanje konjima. Usporedite funkcije uzgoja najpoznatijih alata, otkrijte na što zaista trebate obratiti pažnju i svjesno odaberite software koji odgovara vašem uzgajalištu — velikom ili malom.",
      pills: [
        {
          icon: "Baby",
          label: "Ciklus kobile",
        },
        {
          icon: "Heart",
          label: "Kontrola bređosti",
        },
        {
          icon: "Sparkles",
          label: "Razvoj ždrebeta",
        },
        {
          icon: "FileText",
          label: "Matična knjiga",
        },
      ],
      ctas: [
        {
          label: "Počnite besplatno s modulom za uzgoj",
          href: "#start",
          primary: true,
        },
        {
          label: "Na tablicu usporedbe",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zašto obična aplikacija za upravljanje konjima nije dovoljna za uzgoj.",
      lead: "Većina aplikacija za konjički sport dizajnirana je za jednog sportskog ili rekreacijskog konja. Uzgoj ima sasvim drugi ritam: tjeranje, inseminacija, kontrola bređosti, ultrazvuci, kalendar ždrebljenja, rodovnica i prodaja. Jedan Excel se nakon 2 sezone raspadne — a s više kobila gubite pregled.",
      items: [
        "Kada je bio zadnji ciklus Bonite?",
        "Koji pastuh je planiran za parenje sljedeće sezone?",
        "Je li ultrazvuk na 21. dan već zakazan?",
        "Koja ždrebad iz 2024. su već prodana?",
        "Gdje se nalazi rodovnik do djeda s majčine strane?",
        "Gdje su uzorci DNA i podaci putovnice?",
      ],
    },
    what: {
      title: "Što je software za uzgoj konja?",
      lead: "Software za uzgoj je specijaliziran dosje po kobili i pastuhu, kombiniran s kalendarom uzgojne godine, planiranjem bređosti, registracijom ždrebadi i prikazom rodovnice. Nije opći dnevnik za konje, već alat koji razumije ciklus uzgoja: od prvog tjeranja do odbića.",
      targetGroupsTitle: "Za koji tip uzgajivača je namijenjen software za uzgoj?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Uzgajivač hobist (1-3 kobile)",
          body: "Jedno ili dva parenja godišnje — pregled bez akrobatike u Excelu.",
        },
        {
          icon: "Building2",
          title: "Malo uzgajalište (4-10 kobila)",
          body: "Plan uzgojne godine s ciklusom, inseminacijom, kontrolama bređosti i dosjeom ždrebeta.",
        },
        {
          icon: "Users",
          title: "Profesionalno uzgajalište (10+)",
          body: "Više zaposlenika, izbor pastuha po kobili, prodaja i marketing.",
        },
        {
          icon: "Target",
          title: "Vlasnik pastuha",
          body: "Povijest narudžbi, statistike sjemena i raspored po pastuhu.",
        },
        {
          icon: "Heart",
          title: "Transplantacija embrija",
          body: "Donorska i primateljska kobila kao povezani dosje, ET-kalendar.",
        },
        {
          icon: "ClipboardList",
          title: "Registracija u matičnoj knjizi",
          body: "Uzorci DNA, dokumenti putovnice i podaci rodovnice.",
        },
      ],
    },
    criteria: {
      title: "Što dobar software za uzgoj mora ispunjavati?",
      lead: "Nije svaka 'funkcija uzgoja' u konjičkoj aplikaciji ista. Pet ključnih područja gdje uzgajivači gube puno vremena — i gdje software zaista čini razliku.",
      items: [
        {
          icon: "Calendar",
          title: "Ciklus kobile i tjeranje",
          body: "Dnevni zapis, prediktivna ovulacija, praćenje po ciklusu i automatski podsjetnici.",
        },
        {
          icon: "Heart",
          title: "Inseminacija i kontrola bređosti",
          body: "Datum parenja i inseminacije, podaci o pastuhu, ultrazvuk na 14., 21., 60. dan i određivanje spola.",
        },
        {
          icon: "Baby",
          title: "Razvoj ždrebeta",
          body: "Podaci o porodu, grafikon tjelesne mase, program odvšavanja, trenutak odbića, registracija putovnice.",
        },
        {
          icon: "FileText",
          title: "Rodovnica i dokumenti",
          body: "Prikaz rodovnice do 4-5 generacija, DNA, brojevi putovnica i status u matičnoj knjizi.",
        },
        {
          icon: "Target",
          title: "Izbor pastuha i sparivanje",
          body: "Filtriranje po disciplini, linijama, podacima o pastuhu i dosadašnjem uspjehu — ne samo ono što vlasnik pastuha promovirá.",
        },
        {
          icon: "Share2",
          title: "Suradnja s veterinarom/inseminatorom",
          body: "Ultrazvuci, uzorci i statusi izravno podijeljeni s ordinacijom koja radi s vašim kobilama.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs ostali software za uzgoj.",
      lead: "Pretraživanje softvera za uzgoj konja često prikazuje generičke konjičke aplikacije koje uzgoj spominju u jednoj rečenici. Pošteno uspoređujemo koji alati zaista imaju potpun uzgojni tijek.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Besplatan početak",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Bilježenje ciklusa kobile",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Datum inseminacije + pastuh",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrazvuci i kontrola bređosti",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Očekivani datum ždrebljenja",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dosje ždrebeta (masa/rast)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rodovnica do 4-5 generacija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA i registracija putovnice",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Izbor pastuha / sparivanje",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / transplantacija embrija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pregled više kobila",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilno (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dijeljenje s veterinarom",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrirano s općim dosjeom",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prodaja i marketing ždrebadi",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Usporedba na temelju javno dostupnih funkcija u siječnju 2026. EquineGenie je snažan u uzgoju, ali slabiji u mobilnom korištenju i općem upravljanju konjima. EquiSight kombinira oboje.",
    },
    why: {
      title: "Zašto EquiSight uzgajivačima pruža drugačiju uslugu.",
      lead: "Mnogi uzgajivači koriste zasebni software za uzgoj i zasebnu aplikaciju za upravljanje konjima. EquiSight kombinira oboje — bez prebacivanja između aplikacija ili dvostrukog unosa podataka.",
      points: [
        {
          icon: "Heart",
          title: "Uzgojna kobila ostaje i obični konj",
          body: "Uzgojna kobila ima uzgojnu godinu i obični dosje konja — zdravlje, cijepljenja, potkivač. Jedna aplikacija, svi moduli.",
        },
        {
          icon: "Sparkles",
          title: "Prediktivno umjesto reaktivnog",
          body: "Predviđanje ciklusa, podsjetnici za ključne trenutke bređosti i kalendar ždrebljenja — automatski na temelju vaših podataka.",
        },
        {
          icon: "Share2",
          title: "Svi oko uzgoja",
          body: "Inseminator, vlasnik pastuha, veterinar, kupac, matična knjiga — svi imaju pristup s odgovarajućim pravima.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Po disciplini · od ciklusa do odbića",
      title: "Što uzgojni dosje u EquiSightu sadrži.",
      lead: "Za svaku kobilu dobivate potpun uzgojni dosje, povezan s njezinim redovnim dosjeom konja.",
      items: [
        "Dnevni zapis ciklusa s predviđanjem",
        "Inseminacija/parenje + podaci o pastuhu",
        "Vremenski tijek ultrazvuka (14/21/60 dana + spol)",
        "Ključni trenuci bređosti s automatskim podsjetnicima",
        "Očekivani datum ždrebljenja i pripreme",
        "Dosje ždrebeta od poroda",
        "Rodovnica do djeda/bake s navigacijom klikom",
        "Uzorak DNA, putovnica, status u matičnoj knjizi",
        "Prodajni cjevovod s zainteresiranim kupcima",
        "Povijest izbora pastuha po kobili",
      ],
      ctaLabel: "Pogledajte modul za uzgoj",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Za cijelo uzgajalište",
      title: "Pregled više kobila i pastuha.",
      lead: "Kada uzgajate više od 2-3 kobile, pregled svih ciklusa i bređosti postaje ključan.",
      cards: [
        {
          t: "Nadzorna ploča ciklusa",
          d: "Sve kobile jedne pored drugih, s fazom ciklusa i sljedećom radnjom.",
        },
        {
          t: "Cjevovod bređosti",
          d: "Koje su kobile na kojim ključnim točkama bređosti?",
        },
        {
          t: "Kalendar ždrebljenja",
          d: "Očekivani porodi po mjesecu, s usklađenom logistikom.",
        },
        {
          t: "Portfelj pastuha",
          d: "Vlastiti pastuhi ili stalni inseminatori s poviješću narudžbi.",
        },
        {
          t: "Grafikon rodovnice",
          d: "Analiza predaka kroz više generacija i linija.",
        },
        {
          t: "Nadzorna ploča prodaje",
          d: "Koja su ždrebad prodana, rezervirana ili još dostupna.",
        },
      ],
    },
    beforeAfter: {
      title: "Od Excela i rokovnika do EquiSight uzgoja.",
      lead: "Konkretno: ovako se mijenja vaša uzgojna sezona.",
      rows: [
        {
          before: "Ciklus u slobodnoj bilješci",
          after: "Dnevni zapis s predviđanjem",
        },
        {
          before: "Ultrazvuci putem WhatsAppa inseminatoru",
          after: "Zajednički dosje s fotografijama",
        },
        {
          before: "Datum bređosti u rokovniku",
          after: "Automatski podsjetnici za ključne trenutke",
        },
        {
          before: "Putovnica ždrebeta u ladici",
          after: "Dokument povezan s profilom ždrebeta",
        },
        {
          before: "Rodovnica na papiru",
          after: "Klikabilna rodovnica do 4-5 generacija",
        },
        {
          before: "Oglas za prodaju na Marktplaatsu",
          after: "Prodajni cjevovod s popisom zainteresiranih",
        },
      ],
    },
    helper: {
      title: "Koji software za uzgoj odgovara vama?",
      lead: "5 pitanja kako biste utvrdili trebate li potpunu aplikaciju za uzgoj ili vam je dovoljan hobistički alat.",
      questions: [
        {
          id: "mares",
          q: "Koliko kobila za uzgoj upravljate?",
          options: [
            {
              label: "1 kobila",
              score: 1,
            },
            {
              label: "2-5 kobila",
              score: 2,
            },
            {
              label: "Više od 5 kobila",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Koliko često uzgajate godišnje?",
          options: [
            {
              label: "Povremeno (svakih nekoliko godina)",
              score: 0,
            },
            {
              label: "Svake godine 1-2 parenja",
              score: 2,
            },
            {
              label: "Svake godine 3+ parenja",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kako vršite inseminaciju/parenje?",
          options: [
            {
              label: "Prirodno parenje",
              score: 1,
            },
            {
              label: "VI svježe/hlađeno sjeme",
              score: 2,
            },
            {
              label: "ET ili smrznuto sjeme",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Surađujete li s veterinarom/inseminatorom?",
          options: [
            {
              label: "Jedna stalna osoba",
              score: 1,
            },
            {
              label: "Više ordinacija",
              score: 2,
            },
            {
              label: "Međunarodna mreža",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Što trenutno bilježite?",
          options: [
            {
              label: "Excel ili papir",
              score: 1,
            },
            {
              label: "Opća aplikacija za upravljanje konjima",
              score: 2,
            },
            {
              label: "Ništa strukturirano",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Dovoljan je hobistički alat ili Excel — ali EquiSight ostaje praktičan.",
          body: "Za 1 kobilu s prirodnim parenjem svakih nekoliko godina, opširni modul za uzgoj je pretjerano. EquiSight se pokreće besplatno i modul za uzgoj aktivirate samo za godinu kada parite — bez obveze nadogradnje.",
          cta: "Počnite besplatno",
        },
        mid: {
          title: "EquiSight uzgoj je pravi alat za vas.",
          body: "Imate više kobila ili više metoda uzgoja — za to opće konjičke aplikacije nisu napravljene. EquiSight kombinira uzgoj i opću njegu, tako da ne prebacujete između dva alata.",
          cta: "Pogledajte modul za uzgoj",
        },
        high: {
          title: "EquiSight je izgrađen za vaše uzgajalište.",
          body: "Više kobila, ET ili smrznuto sjeme, međunarodni tim — većina alata ovdje zakazuje. EquiSight raste zajedno s vama do razine uzgajališta bez gomilanja dodatnih licenci.",
          cta: "Razgovarajte s nama o planu za uzgajalište",
        },
      },
    },
    faqTitle: "Često postavljana pitanja o softveru za uzgoj",
    faq: [
      {
        q: "Koji je najbolji software za uzgoj konja?",
        a: "Za 1 kobilu bez složene metode uzgoja mnogi alati su dovoljni. Od 2-3 kobile, korištenja VI ili ET, ili suradnje s veterinarom i matičnom knjigom, potpuni modul za uzgoj postaje ključan. EquiSight kombinira uzgoj s općim upravljanjem konjima u jednoj aplikaciji, tako da ne morate prebacivati.",
      },
      {
        q: "Koje funkcije uzgoja su mi zaista potrebne?",
        a: "Minimalno: zapis ciklusa, podaci o inseminaciji/parenju, ključni trenuci kontrole bređosti i dosje ždrebeta. Opcionalno ali moćno: prikaz rodovnice, arhiv izbora pastuha, DNA/putovnica i prodajni cjevovod.",
      },
      {
        q: "Može li EquiSight predvidjeti ciklus kobile?",
        a: "Da. EquiSight koristi prethodne podatke o ciklusu kako bi prikazao predviđenu ovulaciju, tako da planirate inseminaciju ili parenje u pravo vrijeme — bez svakodnevnog nagađanja.",
      },
      {
        q: "Funkcionira li EquiSight i za transplantaciju embrija?",
        a: "Da. Donorska i primateljska kobila dobivaju povezane dosjee, ET-kalendar i zajedničke ključne trenutke s ordinacijom. Tako ne gubite vremenski tijek u složenom ET-procesu.",
      },
      {
        q: "Mogu li uvesti svoje postojeće uzgojne podatke?",
        a: "Možete ručno unijeti podatke o ciklusima, parenjima i ždrebadi ili ih uvesti skupno putem CSV-a. Za aktivna uzgajališta pomažemo s jednokratnom migracijom ako imate podatke za više sezona.",
      },
      {
        q: "Kako dijelim dosje sa svojim veterinarom ili inseminatorom?",
        a: "Svaka osoba dobiva pristup s ulogom: veterinar, inseminator, vlasnik pastuha ili službenik matične knjige. Svako vidi samo informacije potrebne za svoju ulogu — nije potreban potpuni pristup.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Softver za jahalište: potpuna usporedba i vodič za odabir 2026",
      description: "Usporedite softver za jahalište za satove, jahače, konje i administraciju. Otkrijte koja aplikacija odgovara vašem jahalište ili konjičkom pansionatu.",
      keywords: [
        "softver za jahalište",
        "aplikacija za upravljanje stajom",
        "administrativni softver za jahalište",
        "planiranje satova jahanja",
        "softver za konjički pansionat",
        "administracija jahača",
        "administracija konja u jahalište",
      ],
    },
    hero: {
      eyebrow: "Vodič za odabir · softver za jahalište",
      breadcrumbLabel: "Softver za jahalište",
      title: "Softver za jahalište: potpuni vodič za odabir za jahalište i konjičke pansionate.",
      intro: "Planiranje satova, administracija jahača, upravljanje konjima, fakturiranje i komunikacija — dobar softver za jahalište spaja sve zajedno. Usporedite najpopularnije opcije i otkrijte koja odgovara vašoj staji ili jahalište.",
      pills: [
        {
          icon: "Calendar",
          label: "Planiranje satova",
        },
        {
          icon: "Users",
          label: "Jahači i klijenti",
        },
        {
          icon: "Heart",
          label: "Njega konja",
        },
        {
          icon: "CreditCard",
          label: "Fakturiranje",
        },
      ],
      ctas: [
        {
          label: "Zatražite demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Na tablicu usporedbe",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zašto raspršeni alati usporavaju jahalište.",
      lead: "Većina jahalište radi na zakrpanom sustavu: planiranje satova na bijeloj ploči, registracija jahača u Excelu, fakturiranje u drugom alatu, njega konja u WhatsAppu i kontakt s vlasnicima putem privatnih poruka. U užurbanom tjednu dolazi do dvostrukih rezervacija, zaboravljenih faktura ili konja koji ne znaju kojeg jahača dobivaju.",
      items: [
        "Tko sada ima sat s Jasminom?",
        "Koji jahač još nije platio za ožujak?",
        "Koji konj ovaj tjedan ne smije biti u upotrebi?",
        "Tko su hitni kontakti učenika?",
        "Je li vlasnik Starprašine već primio fakturu za potkivača?",
        "Koji konj stoji u kojoj boksu?",
      ],
    },
    what: {
      title: "Što je softver za jahalište?",
      lead: "Softver za jahalište kombinira planiranje satova, administraciju jahača, upravljanje konjima, fakturiranje i komunikaciju u jednom alatu. Bez Excel-akrobacije ili WhatsApp-kaosa, već jedno mjesto gdje jahalište funkcionira i gdje vlasnici/jahači mogu pratiti sve.",
      targetGroupsTitle: "Za koji tip tvrtke je namijenjen softver za jahalište?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Malo jahalište (1-15 konja)",
          body: "Uglavnom planiranje satova i plaćanja — administracija bez glavobolje.",
        },
        {
          icon: "Users",
          title: "Srednje jahalište (15-40 konja)",
          body: "Više instruktora, planiranje satova + raspored konja + administracija jahača.",
        },
        {
          icon: "ClipboardList",
          title: "Velika jahalačka staja i pansionat (40+)",
          body: "Potpuno upravljanje uključujući fakturiranje, planiranje hrane i potkivača.",
        },
        {
          icon: "Heart",
          title: "Konjički pansionat",
          body: "Portal za vlasnike, individualne upute za njegu, zajednički kalendar.",
        },
        {
          icon: "Target",
          title: "Trening staja za preskakanje prepreka",
          body: "Planiranje natjecanja, trening po konju, kontakt s klijentima.",
        },
        {
          icon: "FileText",
          title: "Konjički poduzetnici",
          body: "Kombinacija satova + pansionata + klinika + trgovine — sve iz jednog sustava.",
        },
      ],
    },
    criteria: {
      title: "Što mora zadovoljiti dobar softver za jahalište?",
      lead: "Lijepa aplikacija ne znači ništa ako vaši zaposlenici ne žele raditi s njom. Pet praktičnih kriterija koji čine razliku između uspjeha i frustracije.",
      items: [
        {
          icon: "Calendar",
          title: "Planiranje satova na više razina",
          body: "Početnici/napredniji, dresura/preskakanje, veze s konjima i kalendari instruktora — sve vidljivo istovremeno.",
        },
        {
          icon: "Users",
          title: "Administracija jahača",
          body: "Profili, razina, pretplata, kartice sati i veze članova obitelji za mlade jahače.",
        },
        {
          icon: "Heart",
          title: "Raspored konja",
          body: "Koji konj se koliko često koristi, s periodima odmora, ozljede i oporavka.",
        },
        {
          icon: "CreditCard",
          title: "Fakturiranje i pretplate",
          body: "Mjesečne pretplate, kartice sati, pojedinačni satovi i automatska naplata.",
        },
        {
          icon: "Share2",
          title: "Portal za vlasnike (pansionat)",
          body: "Vlasnici vide svog konja u vlastitoj aplikaciji — kalendar, troškovi, potkivač i bilješke bez telefoniranja.",
        },
        {
          icon: "Bell",
          title: "Komunikacija i podsjetnici",
          body: "Automatski podsjetnici za satove, obavijesti o plaćanju, najave potkivača — bez slanja poruka.",
        },
      ],
    },
    comparison: {
      title: "EquiSight u odnosu na drugi softver za jahalište.",
      lead: "Mnogi alati za jahalište su snažni u planiranju satova ili fakturiranju, ali rijetko u njezi konja i komunikaciji s vlasnicima zajedno. Pošteno ih stavljamo jedne uz druge.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Besplatan početak / probno razdoblje",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planiranje satova",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Više instruktora",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administracija jahača",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Raspored konja",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Njega konja (cijepljenje/potkivač)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kartica sati / pretplata",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online plaćanja",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatsko fakturiranje",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal za vlasnike (pansionat)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracija potkivača/veterinara",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS podsjetnici",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilni (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planiranje natjecanja",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prikladno za konjički pansionat",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Usporedba temeljena na javno dostupnim značajkama u siječnju 2026. Stalmanager je snažan u administraciji, EquiSight se ističe u tijeku rada pansionata + njezi konja + portalu za vlasnike.",
    },
    why: {
      title: "Zašto je EquiSight drugačiji za jahalište i konjičke pansionate.",
      lead: "EquiSight ide dalje od planera satova. Jahalište vidimo kao cjelovitu operaciju: konji, ljudi, komunikacija i novac — sve međusobno ovisno.",
      points: [
        {
          icon: "Heart",
          title: "Konj u središtu, ne kalendar",
          body: "Svaki konj ima vlastiti dosje. Angažman u satovima, zdravlje, potkivač i natjecanja u jednoj vremenskoj crti — ne 3 odvojena alata.",
        },
        {
          icon: "Share2",
          title: "Vlasnici prate sve bez telefoniranja",
          body: "Vlasnici konjičkog pansionata imaju vlastiti pregled: troškovi, planiranje, fotografije i bilješke — uštedite 5-10 telefonskih poziva tjedno.",
        },
        {
          icon: "Bell",
          title: "Automatska komunikacija",
          body: "Podsjetnik za sat, podsjetnik za cijepljenje, faktura — automatski, putem aplikacije/emaila/SMS-a. Nema više grupnih WhatsApp poruka.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Za konjički pansionat",
      title: "Što konjički pansionat dobiva od EquiSighta.",
      lead: "Konjički pansionati imaju jedinstvene izazove koje obični softver za jahalište ne rješava.",
      cards: [
        {
          t: "Portal za vlasnike",
          d: "Svaki vlasnik vidi samo svog konja (konje), kalendar i troškove.",
        },
        {
          t: "Upute za njegu po konju",
          d: "Hrana, voluminozna hrana, dodaci, raspored deka — vidljivo za staju.",
        },
        {
          t: "Zajednički kalendar",
          d: "Potkivač, veterinar i posjete vlasnika u jednom pregledu.",
        },
        {
          t: "Troškovi potrošnje po konju",
          d: "Prostirka, hrana, krafthrana naplaćeni po vlasniku.",
        },
        {
          t: "Hitni kontakti za konja",
          d: "Vlasnik + veterinar + potkivač uvijek dostupni za staju.",
        },
        {
          t: "Upravljanje ispašom",
          d: "Koji konji odlaze na pašnjak, na odmor ili u rehabilitaciju?",
        },
      ],
    },
    beforeAfter: {
      title: "Od bijele ploče + Excela do EquiSighta.",
      lead: "Konkretno: ovako se mijenja radni tjedan u jahalište.",
      rows: [
        {
          before: "Bijela ploča s planiranjem satova",
          after: "Planiranje uživo po instruktoru",
        },
        {
          before: "Excel s jahačima + bilješkama o satovima",
          after: "CRM za klijente s poviješću satova",
        },
        {
          before: "WhatsApp poruke vlasnicima",
          after: "Portal za vlasnike za njihovog konja",
        },
        {
          before: "Ručna mjesečna naplata",
          after: "Automatsko fakturiranje + iDEAL",
        },
        {
          before: "Njega konja na oglasnoj ploči od papira",
          after: "Upute za njegu po konju, dijeljeno",
        },
        {
          before: "Usmeni dogovor s potkivačem",
          after: "Planiranje potkivača s potvrdama",
        },
      ],
    },
    helper: {
      title: "Koji softver za jahalište odgovara vama?",
      lead: "5 pitanja kako biste vidjeli je li EquiSight prava platforma za vaše jahalište ili konjički pansionat.",
      questions: [
        {
          id: "size",
          q: "Koliko konja imate u svom poslovanju?",
          options: [
            {
              label: "Manje od 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Više od 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Koja je vaša glavna djelatnost?",
          options: [
            {
              label: "Uglavnom poučavanje jahanja",
              score: 1,
            },
            {
              label: "Konjički pansionat (konji na pansionatu)",
              score: 3,
            },
            {
              label: "Kombinacija satova + pansionata",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "S koliko instruktora radite?",
          options: [
            {
              label: "Samo ja sam",
              score: 1,
            },
            {
              label: "2-3 instruktora",
              score: 2,
            },
            {
              label: "4 ili više",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kako trenutno uređujete fakturiranje?",
          options: [
            {
              label: "Ručno (Word/Excel)",
              score: 3,
            },
            {
              label: "Zasebni računovodstveni program",
              score: 2,
            },
            {
              label: "Integrirano u alat za satove",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kako komunicirate s vlasnicima?",
          options: [
            {
              label: "Osobno / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portal za vlasnike u alatu",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lagani alat ili Excel može za sada — ali EquiSight raste s vama.",
          body: "Za malo jahačko poduzeće s jednim instruktorom i malo pansionata, opsežan paket nije odmah potreban. EquiSight počinje besplatno i raste zajedno s vašim jahalište — bez boli pri migraciji za nekoliko godina.",
          cta: "Počnite besplatno",
        },
        mid: {
          title: "EquiSight je logična nadogradnja za vaše jahalište.",
          body: "Više instruktora, kombinacija satova i pansionata, ili fakturiranje koje je trenutno odvojeno — EquiSight to spaja u jedan tijek rada. Posebno portal za vlasnike uštedi puno ad-hoc komunikacije.",
          cta: "Zatražite demo",
        },
        high: {
          title: "EquiSight je izgrađen za vašu veličinu.",
          body: "Konjički pansionat + satovi + više instruktora upravo je ono gdje se EquiSight ističe od klasičnog softvera za jahalište. Portal za vlasnike i integracija njege konja tjedno štede sate administracije i komunikacije.",
          cta: "Zakažite demo za vašu staju",
        },
      },
    },
    faqTitle: "Često postavljana pitanja o softveru za jahalište",
    faq: [
      {
        q: "Koji je najbolji softver za jahalište?",
        a: "Za čisto planiranje satova postoji nekoliko dobrih opcija. Čim vam je potreban konjički pansionat, više instruktora ili praćenje njege konja, EquiSight postaje cjelovito rješenje — bez žongliranja alatima, sve na jednom mjestu.",
      },
      {
        q: "Mogu li uvesti postojeće klijente i satove?",
        a: "Da. Podatke o klijentima i rasporede satova možete uvesti putem CSV-a. Pomažemo aktivnim jahalište s jednokratnom migracijom kako ne biste morali ručno unositi 200 jahača.",
      },
      {
        q: "Funkcionira li i za konjički pansionat bez satova?",
        a: "Da. Način rada pansionata isključuje satove i fokusira se na portal za vlasnike, hranu/njegu, planiranje potkivača i obračun troškova po konju.",
      },
      {
        q: "Mogu li se jahači sami upisivati i plaćati?",
        a: "Da. Jahači mogu putem vlastitog računa vidjeti koji su satovi dostupni, upisati se, platiti kotizaciju putem iDEAL-a i kupiti kartice sati.",
      },
      {
        q: "Kako stoji privatnost podataka o konjima i vlasnicima?",
        a: "Svaka osoba ima ulogu (vlasnik, jahač, instruktor, zaposlenik). Po ulozi vidite samo ono što vam je potrebno. Vlasnici vide samo svog konja, jahači samo vlastite satove.",
      },
      {
        q: "Može li se EquiSight povezati s mojim računovodstvenim softverom?",
        a: "Da, dostupne su veze s Exact, Moneybird i e-Boekhouden. Fakture tada automatski prolaze u vaše računovodstvo.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trener aplikacija za konje: usporedba i vodič za trenere 2026",
      description: "Usporedite trener aplikacije za konje i jahače: dnevnik treninga, video, ciljevi, analiza protokola i upravljanje klijentima. Pronađite pravi alat za trenere.",
      keywords: [
        "trener aplikacija za konje",
        "instruktor aplikacija",
        "aplikacija za trening konja",
        "aplikacija za coaching jahača",
        "dnevnik treninga konja",
        "analiza dresurnog protokola",
        "softver za trenere konja",
      ],
    },
    hero: {
      eyebrow: "Vodič za odabir · softver za trenere",
      breadcrumbLabel: "Trener aplikacija",
      title: "Trener aplikacija za konje: potpuni vodič za instruktore i trenere.",
      intro: "Trener ili instruktor žonglira s kombinacijama, satovima, videima, ciljevima i natjecanjima. Usporedite najbolje trener aplikacije za ljude iz konjičkog sporta i odaberite platformu koja će pratiti vaš rast i u 2026. godini.",
      pills: [
        {
          icon: "Target",
          label: "Ciljevi i planiranje",
        },
        {
          icon: "Video",
          label: "Video analiza",
        },
        {
          icon: "TrendingUp",
          label: "Napredak",
        },
        {
          icon: "Users",
          label: "Klijenti/kombinacije",
        },
      ],
      ctas: [
        {
          label: "Počnite besplatno kao trener",
          href: "#start",
          primary: true,
        },
        {
          label: "Na tablicu usporedbe",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zašto WhatsApp coaching koči trenere.",
      lead: "Većina trenera radi s odvojenim alatima: WhatsApp za komunikaciju, bilježnica za satove, YouTube ili WeTransfer za videe i Excel za rezultate natjecanja. S 5 jahača to funkcionira. S 20 jahača informacije se gube, zaboravljate ciljeve i gubite pregled nad individualnim napretkom.",
      items: [
        "Gdje je zabilježen cilj Anoukin za ovu sezonu?",
        "Koji video sam prošlog mjeseca poslao Bramu?",
        "Je li Lara vidjela analizu protokola s njezinog posljednjeg natjecanja?",
        "Koja kombinacija trenira koliko puta tjedno?",
        "Je li vlasnik Stardustu pročitao moje upute za trening?",
        "Kada sam zadnji put dao povratnu informaciju o neujednačenom impulsu?",
      ],
    },
    what: {
      title: "Što je trener aplikacija za konje i jahače?",
      lead: "Trener aplikacija kombinira coaching-CRM (kombinacije, satovi, ciljevi), dnevnik treninga po konju, video povratne informacije, planiranje natjecanja i analizu protokola. Više nema odvojenih WhatsApp/YouTube/Excel alata — samo jedna platforma na kojoj trener i jahač zajedno rade.",
      targetGroupsTitle: "Za koji tip trenera je ovo namijenjeno?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dresurni instruktor",
          body: "Skeniranje protokola, povezivanje komentara sudaca s ciljevima treninga, praćenje napretka.",
        },
        {
          icon: "Activity",
          title: "Trener skakanja",
          body: "Planiranje parkura, povratne informacije po kolima, upravljanje visinama po konju.",
        },
        {
          icon: "Award",
          title: "Eventing coach",
          body: "Tri discipline, tri plana — sve vidljivo usporedno.",
        },
        {
          icon: "TrendingUp",
          title: "Performance coach (sport)",
          body: "EPI praćenje, natjecanja, ciljevi — za vrhunske sportaše i njihove timove.",
        },
        {
          icon: "Users",
          title: "Jahački klub instruktor",
          body: "Grupni satovi + individualni coaching u jednoj aplikaciji.",
        },
        {
          icon: "Heart",
          title: "Rekreativni coach",
          body: "Hipoterapija, početnici, vlasnici s jednim konjem.",
        },
      ],
    },
    criteria: {
      title: "Što mora sadržavati dobra trener aplikacija?",
      lead: "Treniranje je ljudski posao, ali pravi alat čini vas 30-50% učinkovitijima i pomaže jahačima da napreduju i između satova.",
      items: [
        {
          icon: "Users",
          title: "Upravljanje kombinacijama",
          body: "Konj + jahač kao jedna cjelina, s razinom, ciljevima, napretkom i poviješću.",
        },
        {
          icon: "ClipboardList",
          title: "Bilješke sa sata i ciljevi",
          body: "Po satu bilješka s fokusnim točkama, povezana s dugoročnim ciljevima.",
        },
        {
          icon: "Video",
          title: "Video povratne informacije",
          body: "Učitajte video, označite trenutke, dodajte govorni ili pisani feedback.",
        },
        {
          icon: "Target",
          title: "Natjecanja i analiza protokola",
          body: "Skenirajte protokole (KNHS/FEI), vidite ocjene po elementima, komentare sudaca i trendove.",
        },
        {
          icon: "Calendar",
          title: "Planiranje i kartice sati",
          body: "Kalendar, plaćanja, pretplate i automatski podsjetnici.",
        },
        {
          icon: "Share2",
          title: "Komunikacija prema jahaču",
          body: "Jahač vidi svoju stranicu sa satovima, videima, ciljevima i feedbackom.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs druge trener aplikacije.",
      lead: "Neki alati za trenere fokusiraju se na zamjenu WhatsAppa, drugi na analizu protokola. EquiSight kombinira oboje s pravim dosjeom konja — tako da jahač napreduje i između satova.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Besplatan početak",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Upravljanje kombinacijama",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Bilješke sa sata i feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dugoročni ciljevi",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Učitavanje videa + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skeniranje KNHS/FEI protokola",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Performance Index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalendar natjecanja",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal za jahača",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Kartica sati / pretplata",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online plaćanja",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrirani dosje konja",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vidljivost kovača/veterinara",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Za instruktora I jahača",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Više konja po jahaču",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Usporedba temeljena na javno dostupnim značajkama u siječnju 2026. EquiSight je jedinstven po analizi protokola + EPI i kombinira to s općim upravljanjem konjem.",
    },
    why: {
      title: "Zašto EquiSight nudi drugačije iskustvo treniranja.",
      lead: "Većina alata za trenere završava tamo gdje sat prestaje. EquiSight nastavlja — u dosjeu konja, u analizi natjecanja, u suradnji s veterinarom i vlasnikom.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skeniranje protokola → cilj treninga",
          body: "Skenirajte KNHS protokol i odmah vidite koji elementi trebaju pažnju. Ciljevi se automatski ističu.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach pojačava vaše oko",
          body: "Podaci s više satova, natjecanja i protokola otkrivaju obrasce koje ne možete zadržati u glavi.",
        },
        {
          icon: "Share2",
          title: "Integrirano s konjem",
          body: "Trener vidi povijest cijepljenja, kovača i ozljeda konja — nema planiranja treninga za vrijeme oporavka.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Za dressuru i skakanje",
      title: "Što sadrži coaching dosje u EquiSightu.",
      lead: "Svaka kombinacija dobiva coaching stream koji sve drži na jednom mjestu — više nema izgubljenih stvari u WhatsAppu.",
      items: [
        "Bilješke sa sata s fokusnim točkama po sesiji",
        "Dugoročni ciljevi + prekretnice",
        "Učitavanje videa s komentarima na vremenskim oznakama",
        "KNHS/FEI skeniranje protokola s ocjenama",
        "Komentari sudaca povezani s treningom",
        "Rezultati natjecanja i EPI trend",
        "Kontakt s klijentom i povijest satova",
        "Kartica sati / pretplata / računi",
        "Graf napretka po disciplini",
        "Dijeljen pristup s vlasnikom konja",
      ],
      ctaLabel: "Pogledajte modul za trenere",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Od WhatsAppa + YouTubea do EquiSight Trenera.",
      lead: "Konkretno: ovako se mijenja vaš coaching tijek rada.",
      rows: [
        {
          before: "WhatsApp s odvojenim video linkovima",
          after: "Video s feedbackom na vremenskim oznakama u dosjeu",
        },
        {
          before: "Bilježnica po jahaču",
          after: "Coaching log s ciljevima i poviješću",
        },
        {
          before: "Excel s rezultatima natjecanja",
          after: "EPI graf + analiza protokola",
        },
        {
          before: "Usmeni ciljevi",
          after: "Prekretnice s indikatorom napretka",
        },
        {
          before: "Odvojen alat za fakturiranje",
          after: "Satovi + iDEAL + pretplata u aplikaciji",
        },
        {
          before: "E-mail vlasniku o napretku",
          after: "Vlasnik prati u vlastitom prikazu",
        },
      ],
    },
    helper: {
      title: "Koja trener aplikacija odgovara vama?",
      lead: "5 pitanja kako biste vidjeli donosi li specijalizirani coaching alat dodatnu vrijednost vašoj praksi.",
      questions: [
        {
          id: "clients",
          q: "Koliko aktivnih kombinacija trenirate?",
          options: [
            {
              label: "Manje od 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Više od 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Koja je vaša glavna disciplina?",
          options: [
            {
              label: "Dressura",
              score: 3,
            },
            {
              label: "Skakanje",
              score: 2,
            },
            {
              label: "Rekreativno / raznovrsno",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Koristite li video u coachingu?",
          options: [
            {
              label: "Rijetko",
              score: 0,
            },
            {
              label: "Ponekad (ručno)",
              score: 2,
            },
            {
              label: "Često — sustavno",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Trenirate li natjecatelje?",
          options: [
            {
              label: "Ne, rekreativno",
              score: 0,
            },
            {
              label: "Ponekad natjecanja",
              score: 2,
            },
            {
              label: "Mnogo — startne liste su središnje",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Želite li mjeriti svoj coaching?",
          options: [
            {
              label: "Ne, intuicija je dovoljna",
              score: 0,
            },
            {
              label: "Da, ali nemam vremena",
              score: 2,
            },
            {
              label: "Da — coaching temeljen na podacima",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Jednostavan alat ili čak WhatsApp je dovoljan — za sada.",
          body: "Za manje od 5 jahača bez puno videa ili natjecanja, coaching aplikacija je pretjerana. EquiSight počinje besplatno, pa ga možete isprobati kada vaša praksa naraste.",
          cta: "Počnite besplatno",
        },
        mid: {
          title: "EquiSight Trener čini vas sustavno učinkovitijima.",
          body: "S 5-15 kombinacija gubite sate svaki mjesec na WhatsApp i odvojene videe. EquiSight sve objedinjuje, automatski skenira protokole i osigurava da jahači uvijek mogu pregledati svoj feedback.",
          cta: "Isprobajte modul za trenere",
        },
        high: {
          title: "EquiSight je izgrađen za vaš opseg coachinga.",
          body: "Mnogo jahača, video, natjecanja i coaching temeljen na podacima: upravo tu se EquiSight ističe. EPI + skeniranje protokola + dosje konja daje vam prednost koju konkurenti nemaju.",
          cta: "Zakažite demo za vašu coaching praksu",
        },
      },
    },
    faqTitle: "Često postavljana pitanja o trener aplikacijama",
    faq: [
      {
        q: "Koja je najbolja trener aplikacija za konje i jahače?",
        a: "Za čistu komunikaciju mnogi alati su dovoljni (čak i WhatsApp). Za ciljeve, video analizu, skeniranje protokola, praćenje natjecanja i upravljanje klijentima u jednom alatu, EquiSight je najcjelovitije rješenje — posebno jer prati i samog konja, ne samo kombinaciju.",
      },
      {
        q: "Može li EquiSight automatski čitati natjecateljske protokole?",
        a: "Da. Učitajte KNHS ili FEI protokol i EquiSight izvlači ocjene po elementima, komentare sudaca i povezuje ih s kombinacijom. Trendove vidite kroz više natjecanja.",
      },
      {
        q: "Što je EPI (Equestrian Performance Index)?",
        a: "EPI je EquiSight rezultat koji pretvara više natjecateljskih rezultata u usporedivi indeks izvedbe. Na taj način vidite pravi napredak kroz različite klase i suce.",
      },
      {
        q: "Mogu li jahači sami rezervirati i platiti satove?",
        a: "Da. Jahači se prijave, vide dostupne termine satova, kupuju kartice sati i plaćaju putem iDEAL-a. Vi ododbravate ili odbijate ono što želite ponuditi.",
      },
      {
        q: "Funkcionira li i za instruktora koji radi oko jahačkog kluba?",
        a: "Da. Možete raditi kao slobodni trener s vlastitim klijentima bez potrebe za povezivanjem s računom jahačkog kluba. Klijenti vam plaćaju izravno.",
      },
      {
        q: "Mogu li migrirati postojeće videe i bilješke?",
        a: "Videe možete učitati po kombinaciji ili putem alata za grupno učitavanje. Uvoz bilješki putem CSV-a. Pomažemo aktivnim trenerima s jednokratnom migracijom.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Vodiči i pomagala za odabir softvera za upravljanje konjima | EquiSight",
      description: "Svi EquiSight vodiči na jednom mjestu: usporedbe softvera za upravljanje konjima, uzgoj, jahačke škole i trenere, plus pomagala za odabir za 2026.",
      keywords: [
        "vodiči za softver za konje",
        "pomagalo za odabir upravljanja konjima",
        "usporedba softvera za uzgoj",
        "vodič za softver jahačke škole",
        "usporedba aplikacija za trenere",
      ],
    },
    hub: {
      eyebrow: "Hub · vodiči",
      breadcrumbLabel: "Vodiči",
      title: "Četiri potpuna vodiča za odabir pravog softvera za konje.",
      intro: "Za svaku ciljnu skupinu postoji detaljno pomagalo za odabir: tablice usporedbe, kriteriji, primjeri i interaktivni kviz. Kliknite na vodič koji odgovara vašoj situaciji ili najprije istražite produbljena članci ispod svakog klastera.",
      stats: {
        guides: "4 pomagala za odabir",
        articles: "15 produbljenih članaka",
        fair: "Poštena usporedba",
      },
      readMoreCta: "Pročitajte potpuni vodič",
      relatedHeading: "Produbljeni članci",
      articlesCountSingular: "{{count}} produbljeni članak",
      articlesCountPlural: "{{count}} produbljenа članka",
      articlesCountAria: "Broj klaster-članaka",
      lastUpdatedPrefix: "Ažurirano",
      lastUpdatedAria: "Datum posljednjeg ažuriranja ovog klastera",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Pomagalo za odabir aplikacije za upravljanje konjima",
        blurb: "Usporedite najpopularnije aplikacije za upravljanje konjima i otkrijte koja odgovara vlasniku, štali ili uzgajivaču. Uključuje poštenu tablicu usporedbe i pomagalo s 5 pitanja.",
        audience: "Za vlasnike, stajske upravitelje i sve ljubitelje konja koji traže pregled.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Usporedba softvera za uzgoj konja",
        blurb: "Od ciklusa kobila do razvoja ždrebadi: pogledajte koji softver za uzgoj zaista funkcionira za vaš broj kobila, metodu uzgoja i zahtjeve matične knjige.",
        audience: "Za (hobby) uzgajivače, ergele i vlasnike pastuha.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Pomagalo za odabir softvera za jahačku školu",
        blurb: "Planiranje sati, administracija jahača, portal za vlasnike i fakturiranje — sve u jednom alatu. Usporedite opcije za jahačke škole i pansionske štale u 2026.",
        audience: "Za jahačke škole, pansionske štale i konjičke poduzetništva.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Pomagalo za odabir aplikacije za trenere",
        blurb: "Coaching-CRM, video-povratne informacije, skeniranje KNHS-protokola i ciljevi po kombinaciji. Koja aplikacija za trenere odgovara vašoj trenerskoj praksi?",
        audience: "Za instruktore, trenere i koučeve.",
      },
    ],
    closing: {
      eyebrow: "Zašto ovi vodiči",
      title: "Poštena usporedba, ne samo cijene.",
      body1: "Mnoge \"stranice za usporedbu\" su zapravo prikrivene reklame. Naši vodiči postavljaju funkcije, ciljne skupine i konkurente jedne pored drugih onako kako bi to učinio neovisni izvor znanja. EquiSight se naravno ističe kao cjelovito rješenje, ali možete pročitati i gdje su druge aplikacije jače.",
      body2: "Produbljeni članci ispod svakog vodiča odgovaraju na konkretna pitanja koja proizlaze iz odabira: \"Kada prvi ultrazvuk nakon inseminacije\", \"Kako automatizirati fakturiranje jahačke škole\", \"Kako analizirati natjecateljski protokol\". Bez marketinškog žargona, samo praksa.",
    },
    hubName: "EquiSight Vodiči",
  },
  ui: {
    sectionEyebrows: {
      pains: "Zašto ovo boli",
      basics: "Osnove",
      criteria: "Što ga čini dobrim?",
      comparison: "Poštena usporedba",
      why: "Razlika",
      beforeAfter: "Od rascjepkanosti do pregleda",
      helper: "5 pitanja",
    },
    table: {
      feature: "Funkcija",
      today: "Danas",
      withEquisight: "S EquiSight-om",
    },
    helper: {
      questionLabel: "Pitanje {{current}} od {{total}}",
      answerPrompt: "Odgovorite na još {{count}} pitanje kako biste vidjeli preporuku.",
      answerPromptPlural: "Odgovorite na još {{count}} pitanja kako biste vidjeli preporuku.",
      resultEyebrow: "Vaš rezultat",
    },
    targetGroupsFallback: "Za koga je ovo namijenjeno?",
    faqTitleFallback: "Često postavljana pitanja",
  },
};

export default CORNERSTONES;
